import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { map } from "rxjs";
import { PlatformAuthService } from "./platform-auth.service";

// Guards the /platform console. A platform owner is a distinct principal, so we
// resolve session state through PlatformAuthService (never AuthService). Logged
// out → /platform/login.
export const platformGuard: CanActivateFn = () => {
  const auth = inject(PlatformAuthService);
  const router = inject(Router);

  const decide = () =>
    auth.isAuthed() ? true : router.createUrlTree(["/platform/login"]);

  if (auth.loaded()) return decide();
  return auth.refresh().pipe(map(() => decide()));
};

// Keeps an already-authenticated owner from sitting on the login page.
export const platformLoginGuard: CanActivateFn = () => {
  const auth = inject(PlatformAuthService);
  const router = inject(Router);

  const decide = () =>
    auth.isAuthed() ? router.createUrlTree(["/platform"]) : true;

  if (auth.loaded()) return decide();
  return auth.refresh().pipe(map(() => decide()));
};
